import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux"
import { marketingListActions } from "../../store/marketingListStore"
import { Translate } from "react-localize-redux";
import { withLocalize } from 'react-localize-redux';
import ModalInner from '../layoutItems/modalInner';
import classnames from 'classnames';
import UnderlinedTitle from "../common/underlinedTitle";

class RemoveTemplatePopup extends Component {
    render() {
        return (
            <ModalInner close={this.props.close} title={this.props.translate("MarketingList.Results.ExportPopup.Header")}>
                <div>
                    <UnderlinedTitle header={this.props.translate("MarketingList.TemplatesPopup.RemoveSearchTemplate")} />
                    <div style={{ margin: "1em auto" }}>
                        <Translate id='MarketingList.TemplatesPopup.WantRemoveSearchTemplate' data={{ searchName: this.props.data.name }} />
                    </div>
                    <div className="modal-inner-buttons">
                        <button type="button" onClick={this.props.close} className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id='Common.Button.Cancel' /></button>
                        <button type="button" onClick={this.remove} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id='Common.Yes' /></button>
                    </div>
                </div>
            </ModalInner>
        )
    }

    remove = () => {
        this.props.removeTemplate(this.props.data.requestId)
        this.props.close();
    }
}

export default withLocalize(connect(
    state => { return { marketingList: state.marketingList } },
    dispatch => bindActionCreators(marketingListActions, dispatch)
)(RemoveTemplatePopup));